import Marquee from "react-fast-marquee";

const ITEMS = [
  "ALL YOUR PLUMBING & HYDRONICS UNDER CONTROL",
  "24/7 EMERGENCY SERVICE",
  "GTA WIDE",
  "LICENSED & INSURED",
  "UPFRONT PRICING",
];

export const MarqueeStrip = () => {
  return (
    <div data-testid="marquee" className="border-t-2 border-b-2 border-[#111111] bg-[#FEBE10] py-5 md:py-6">
      <Marquee speed={38} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-bold uppercase tracking-tight text-2xl md:text-4xl text-[#111111] px-6">
              {t}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-[#111111]" />
          </div>
        ))}
      </Marquee>
    </div>
  );
};
